.modalContainer {
    border: none;
    background-color: var(--white);
    padding: 32px;
    width: 100%;
    border-radius: var(--border-radius);
}

.modalContainer > h2 {
    margin-bottom: 8px;
}

.modalButtons {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
}

.modalButtons button:last-child {
    margin-left: 16px;
}

@media screen and (min-width: 663px) {
    .modalContainer {
        width: 663px;
    }
}
